import React from "react";

const VisionMission = () => {
  return (
    <section className="vision-mission">
      <div className="container">
        <div className="content">
          <h2 className="title">Our Vision</h2>
          <p className="text">
          To become a leading global provider of infrastructure, renewable energy, and IT solutions while driving sustainable growth and innovation.
          </p>
        </div>

        <div className="content">
          <h2 className="title">Our Mission</h2>
          <p className="text">
          To deliver top-notch services that empower businesses and communities, foster environmental stewardship, and set new benchmarks of excellence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
